<template>
  <div>
    <div class="breadcrumb">
      <slot name="header">
        <h1>{{ page }}</h1>
      </slot>
    </div>

    <div class="separator-breadcrumb border-top"></div>
  </div>
</template>

<script>
export default {
  name: 'breadcrumb',

  props: ['page', 'folder'],
};
</script>
